import script from "./DiagnosticsLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./DiagnosticsLayout.vue?vue&type=script&setup=true&lang=js"

import "./DiagnosticsLayout.vue?vue&type=style&index=0&id=01a43f56&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01a43f56"]])

export default __exports__